import { getLocalStorageItemSafely } from '../utils/safe-local-storage';
import { isProd } from './is-prod';

export const hideDevStylesKey = 'hideDevStyles';

export function showDevStyles() {
  const hideDevStyles = getLocalStorageItemSafely(hideDevStylesKey) === 'true';
  return !hideDevStyles && !isProd();
}
